/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSupervisorVisitResponseRung } from './oralExamSupervisorVisitResponseRung';

/**
 * One supervisor's visit on a student booking (wire projection).
 */
export interface OralExamSupervisorVisitResponse {
  bookingId: string;
  rung: OralExamSupervisorVisitResponseRung;
  since: string;
}
